module.exports = __webpack_public_path__ + "img/r_rendering_icon_08.6ed84782.png";